import { compose } from 'recompose';
import BrillWithIndex from './brillWithIndex';

const enhance = compose();
export default enhance(BrillWithIndex);
